import { getPrimaryAccount, getAccountData } from "../../../utils/sessionUtil";
import { startDate, todayDate } from "../../../utils/commonUtil";

export const getInvestmentAccountApi = () => {
  return [
    {
      method: "GET",
      url: `/donor-portal/api/investment/${
        getPrimaryAccount().userId
      }/findByAccountIdStartDateAndEndDate?startDateStr=${startDate(
        90
      )}&endDateStr=${todayDate()}`, //end to change endDate to todayDate
      page: "accountSummary"
    },
    {
      method: "GET",
      url: `/donor-portal/api/grant/${
        getPrimaryAccount().userId
      }/findByAccountIdStartDateAndEndDate?startDateStr=${startDate(
        90
      )}&endDateStr=${todayDate()}`, //end to change endDate to todayDate
      page: "accountSummary"
    },
    {
      method: "GET",
      url: `/donor-portal/api/contribution/${
        getPrimaryAccount().userId
      }/findByAccountIdStartDateAndEndDate?startDateStr=${startDate(
        90
      )}&endDateStr=${todayDate()}`, //end to change endDate to todayDate
      page: "accountSummary"
    },
    {
      method: "GET",
      url: `/donor-portal/api/account/${
        getPrimaryAccount().userId
      }/findBalanceByStartDateAndEndDate?startDateStr=${startDate(
        92
      )}&endDateStr=${todayDate()}`, //end to change endDate to todayDate
      page: "accountSummary"
    },
    {
      method: "GET",
      url: `/donor-portal/api/account/${
        getPrimaryAccount().userId
      }/findSummary/${getAccountData().partyId}?startDate=10/04/1970&endDate=${todayDate()}`, //end to change endDate to todayDate
      page: "accountSummary"
    },
    {
      method: "GET",
      url: `/donor-portal/api/otherActivities/${
        getPrimaryAccount().userId
      }/findByAccountIdStartDateAndEndDate?startDateStr=${startDate(
        90
      )}&endDateStr=${todayDate()}`, //end to change endDate to todayDate
      page: "accountSummary"
    },
    {
      method: "GET",
      url: `/donor-portal/api/account/${
        getPrimaryAccount().userId
      }/findBalanceByStartDateAndEndDate?startDateStr=${startDate(
        1827
      )}&endDateStr=${todayDate()}`, //end to change endDate to todayDate
      page: "accountSummary"
    }
  ];
};

export const getSecNavigationAttrForCSR = () => {
  return {
    metaData: {
      method: "GET",
      url: `/donor-portal/api/account/${
        getPrimaryAccount().userId
      }/findAccountAttributesForCSR?partyId=${getAccountData().partyId}`
    }
  };
};

export const getBotGraphData = x => {
  return {
    metaData: {
      method: "GET",
      url: `/donor-portal/api/account/${
        getPrimaryAccount().userId
      }/findBalanceByStartDateAndEndDate?startDateStr=${startDate(
        x + 5
      )}&endDateStr=${todayDate()}`, //end to change endDate to todayDate
      page: "accountSummary"
    }
  };
};
